import React from 'react'
import TopBar from '../../components/TopBar'
import { useEffect } from 'react';
import { baseUrl } from '../../redux/actions/baseUrl';
import axios from 'axios';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AiFillEye } from 'react-icons/ai';
import axiosInstance from '../../axiosInstance';
import swal from "sweetalert";
import { IoMdGitPullRequest } from 'react-icons/io';
import { toast } from 'react-toastify';
import { FaFlask, FaDownload, FaCalendarAlt, FaFileAlt, FaExclamationCircle, FaCheckCircle, FaSpinner } from 'react-icons/fa';

export default function LabResult() {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    const [labFiles, setLabFiles] = useState([]);
    const [loading, setLoading] = useState(true);
    
    const get_lab_result_files = async (user) => {
        console.log('user', user, user.id)
        try {
            setLoading(true);
            const res = await axiosInstance.get(`/lab-results/files?patient=${user}`);
            console.log('lab setLabFiles', res)
            setLabFiles(res.data?.data?.lab_results)
        } catch (err) {
            console.log('err', err)
            toast.error(err?.response?.data?.message ||'Failed to load lab results');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        get_lab_result_files(user.id);
    }, []);

    const requestResult = async (id, patient, file) => {
        let data = {
            test_id: id,
            patient: patient,
            file: file,
            status: 'pending'
        }
        try {
            const response = await axiosInstance.post('/lab-results/request', data);
            toast.success(response.data.message);
        } catch (error) {
            console.log('Error', error);
            toast.error(error?.response?.data?.message || "An error occurred.");
        }
    }

    const handRequest = (id, patient, file) => {
        swal({
            title: "Request this lab result?",
            text: "The file will be sent to your email",
            icon: "info",
            buttons: true,
        }).then((req) => {
            if (req) {
                requestResult(id, patient, file);
            }
        });
    }

    return (
        <div className='min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50'>
            <TopBar title={"Lab Results"} url={-1} />

            <div className="px-4 py-6">
                {/* Hero Section */}
                <div className="bg-white rounded-3xl shadow-xl p-6 mb-6">
                    <div className="flex items-center justify-center mb-4">
                        <div className="w-16 h-16 bg-gradient-to-r from-primary100 to-blue-600 rounded-full flex items-center justify-center">
                            <FaFlask className="text-white text-2xl" />
                        </div>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-800 text-center mb-2">
                        Laboratory Results
                    </h2>
                    <p className="text-gray-600 text-center">
                        Your recent lab result files will appear here and you can request them to be sent to your email.
                    </p>
                </div>

                {/* Loading State */}
                {loading && (
                    <div className="flex flex-col items-center justify-center py-12">
                        <div className="w-16 h-16 bg-gradient-to-r from-primary100 to-blue-600 rounded-full flex items-center justify-center mb-4">
                            <FaSpinner className="text-white text-2xl animate-spin" />
                        </div>
                        <p className="text-gray-600">Loading your lab results...</p>
                    </div>
                )}

                {/* Lab Results List */}
                {!loading && (
                    <div className="space-y-4">
                        {labFiles?.length > 0 ? (
                            labFiles.map((test, i) => (
                                <div key={i} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
                                    <div className="p-6">
                                        {/* Header */}
                                        <div className="flex items-center justify-between mb-4">
                                            <div className="flex items-center space-x-3">
                                                <div className="w-12 h-12 bg-gradient-to-r from-green-400 to-blue-500 rounded-full flex items-center justify-center">
                                                    <FaFileAlt className="text-white text-lg" />
                                                </div>
                                                <div>
                                                    <h3 className="font-semibold text-gray-800">Lab Test Result</h3>
                                                    <div className="flex items-center space-x-2 text-sm text-gray-500">
                                                        <FaCalendarAlt className="text-xs" />
                                                        <span>{test?.created?.substring(0, 16)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex items-center space-x-2">
                                                <div className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium">
                                                    Available
                                                </div>
                                            </div>
                                        </div>

                                        {/* File Info */}
                                        <div className="bg-gray-50 rounded-xl p-4 mb-4">
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center space-x-3">
                                                    <FaFileAlt className="text-gray-400" />
                                                    <div>
                                                        <p className="font-medium text-gray-800">
                                                            {test.image.length > 25 
                                                                ? `${test?.image.substring(0, 25)}...` 
                                                                : test?.image
                                                            }
                                                        </p>
                                                        <p className="text-sm text-gray-500">Lab result file</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Action Button */}
                                        <div className="flex justify-end">
                                            <button 
                                                onClick={() => handRequest(test.id, test.patient, test.image)}
                                                className="flex items-center space-x-2 bg-gradient-to-r from-primary100 to-blue-600 text-white px-6 py-3 rounded-xl font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-200"
                                            >
                                                <FaDownload className="text-sm" />
                                                <span>Request Result</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            // Empty State
                            <div className="bg-white rounded-3xl shadow-xl p-8 text-center">
                                <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                                    <FaExclamationCircle className="text-gray-400 text-3xl" />
                                </div>
                                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                                    No Lab Results Found
                                </h3>
                                <p className="text-gray-600 mb-6">
                                    You don't have any lab results available at the moment. Results will appear here once they're ready.
                                </p>
                                <div className="bg-blue-50 rounded-xl p-4">
                                    <div className="flex items-center justify-center space-x-2 text-blue-700">
                                        <FaCheckCircle className="text-sm" />
                                        <span className="text-sm font-medium">We'll notify you when results are available</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}
